import { render, staticRenderFns } from "./LandscapeProducts.vue?vue&type=template&id=55e2420d"
import script from "./LandscapeProducts.vue?vue&type=script&lang=js"
export * from "./LandscapeProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports